import { Tabs } from "antd";
import { Divider, Modal } from "rsuite";
import {
  StudentClearance,
  StudentDiscount,
  StudentInvoice,
  StudentPayment,
  StudentProfile,
  StudentTransaction,
} from "./data";

export const StudentDetails = (props) => {
  const { open, setOpen, index, setIndex, dataId, registration } = props;

  const items = [
    {
      key: "1",
      label: "Profile",
      children: <StudentProfile dataId={registration} />,
    },
    {
      key: "2",
      label: "Invoice",
      children: <StudentInvoice dataId={dataId} />,
    },
    {
      key: "3",
      label: "Payment",
      children: <StudentPayment dataId={dataId} />,
    },
    {
      key: "4",
      label: "Clearance",
      children: <StudentClearance dataId={dataId} />,
    },
    {
      key: "5",
      label: "Discount",
      children: <StudentDiscount dataId={dataId} />,
    },
    {
      key: "6",
      label: "Transaction",
      children: <StudentTransaction dataId={dataId} />,
    },
  ];

  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
          setIndex(index + 1);
        }}
        size="full"
        backdrop={"static"}
      >
        <Modal.Header>
          <Modal.Title>Student Profile</Modal.Title>
        </Modal.Header>
        <Divider />
        <Modal.Body>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <Tabs
                  defaultActiveKey="1"
                  items={items}
                  className="custom-tabs"
                  destroyInactiveTabPane={true}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Divider style={{ marginTop: -10 }} />
        <Modal.Footer>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6 col-sm-12 d-flex justify-content-start"></div>
              <div className="col-md-6 col-sm-12 d-flex justify-content-end">
                <button
                  onClick={() => {
                    setOpen(false);
                    setIndex(index + 1);
                  }}
                  type="button"
                  className="btn btn-soft-danger btn-label waves-effect waves-light rounded-pill me-3"
                >
                  <i class="bi bi-x-circle label-icon align-middle rounded-pill fs-16 me-2"></i>{" "}
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};
